export * from './core/index';
//# sourceMappingURL=core.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/core.js
// module id = ../../../material/core.js
// module chunks = 3